const sidebarItems = [
    {
        label: 'dashboard',
        route: '/user-dashboard',
        icon: 'HomeModernIcon'
    },
    {
        label: 'discover',
        route: '/recipes',
        icon: 'SearchIcon'
    },
    {
        label: 'learn',
        route: '/learn',
        icon: 'AcademicCapIcon'
    },
    {
        label: 'cookbook',
        route: '/user-recipes',
        icon: 'FolderIcon'
    },
    {
        label: 'create',
        route: '/recipe-creator',
        icon: 'LightBulbIcon'
    },
    {
        label: 'shop',
        route: '/user-shopping-lists',
        icon: 'ClipboardListIcon'
    },
    {
        label: 'plan',
        route: '/user-meal-plans',
        icon: 'CalendarDaysIcon'
    },
    {
        label: 'diary',
        route: '/diary',
        icon: 'BookOpenIcon'
    },
    {
        label: 'pantry',
        route: '/user-stores',
        icon: 'DatabaseIcon'
    },
    {
        label: 'notifications',
        route: '/user-notifications',
        icon: 'BellIcon'
    },
    {
        label: 'account',
        route: '/user-preferences',
        icon: 'AdjustmentsIcon'
    },
]

export default sidebarItems